import { createFileRoute } from '@tanstack/react-router'

import { routeOptions, UserSignUpPage } from '@/modules/auth'

export const Route = createFileRoute('/user-sign-up')({
  staticData: { title: 'Sign up' },
  ...routeOptions,
  component: UserSignUpPage,
})
